module.exports = "/assets/restaurant-festival-menu/banner.png?zJn+PWx";